import { AlertCircle } from "lucide-react";

interface MaintenanceModeProps {
  message?: string;
  estimatedEndTime?: string;
}

export default function MaintenanceMode({
  message = "We're currently performing scheduled maintenance on TradeSage.",
  estimatedEndTime,
}: MaintenanceModeProps) {
  return (
    <div className="min-h-screen bg-muted flex flex-col justify-center items-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-yellow-100 p-4 rounded-full">
            <AlertCircle className="h-12 w-12 text-yellow-600" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-foreground mb-4">
          Maintenance in Progress
        </h1>
        
        <p className="text-muted-foreground mb-6">
          {message}
        </p>
        
        {estimatedEndTime && (
          <div className="bg-blue-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              <span className="font-semibold">Expected completion:</span>
              <br />
              {estimatedEndTime}
            </p>
          </div>
        )}
        
        <p className="text-sm text-muted-foreground">
          We apologize for any inconvenience. Please check back later.
        </p>
      </div>
    </div>
  );
}
